export const supervisorListFields = `
  id
  created_at
  email
  first_name
  full_name
  gender
  last_name
  photo
`;

export const supervisorFindFields = `
  id
  photo
  birthdate
  email
  first_name
  gender
  last_name
  settings {
    language
  }
`;
